<template>
  <div id="app">
    <header class="header">

      <img class="logo" src="./assets/logo.png" />

      <el-menu :default-active="activeIndex" @select="handleSelect"
        background-color="#409eff"
        text-color="#ffffff"
        active-text-color="#ffffff"
        class="menu" mode="horizontal">
        <el-menu-item index="renyang" :disabled="true" class="renyang">仁扬</el-menu-item>
        <el-menu-item index="benchmarks">天梯图</el-menu-item>
        <el-menu-item index="installed-configuration">装机配置</el-menu-item>
      </el-menu>
    </header>

    <el-tabs class="tabs" v-if="activeIndex === 'benchmarks'" v-model="activeBenchmarksIndex" type="card" size="mini">
      <el-tab-pane label="CPU天梯图" name="cpu-benchmarks" size="mini">
        <cpu-benchmarks :globalConfig="globalConfig" />
      </el-tab-pane>
      <el-tab-pane label="显卡天梯图" name="gpu-benchmarks" size="mini">
        <gpu-benchmarks :globalConfig="globalConfig" />
      </el-tab-pane>
    </el-tabs>

    <div class="container" v-if="activeIndex === 'installed-configuration'">
      <el-alert
        title="开发中，敬请期待！"
        description="欢迎关注我的公众号，第一时间查看更新进度！"
        type="success"
        show-icon />
      <about-me :globalConfig="globalConfig" />
    </div>

    <div class="dialog" v-if="openQrcodeDialog">
      <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="80%"
        title="请输入验证码"
        >
        <div class="title">
          <img class="wechat" src="./assets/wechat.png" /> <strong>仁扬</strong> 装机交流
        </div>
        <div class="qrc">
          <img class="img" src="./assets/qrc_sm.jpg" />
        </div>
        <div class="tips">
          <strong>微信扫码</strong> 关注公众号 <strong>获得验证码</strong>
          <el-input placeholder="请输入验证码" v-model="vcode">
            <el-button slot="append" type="primary" @click="verify">验证</el-button>
          </el-input>
          <div class="finish">验证通过后可关闭弹窗，感谢您的关注和支持！</div>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import watermark from './utils'
import CpuBenchmarks from './components/CpuBenchmarks.vue'
import GpuBenchmarks from './components/GpuBenchmarks.vue'
import AboutMe from './components/AboutMe.vue'

export default {
  name: 'App',
  components: {
    CpuBenchmarks,
    GpuBenchmarks,
    AboutMe
  },
  data () {
    return {
      globalConfig: {},
      dialogVisible: true,
      vcode: '',
      constantVcode: '3268',
      activeIndex: 'benchmarks',
      activeBenchmarksIndex: 'cpu-benchmarks'
    }
  },
  mounted () {
    this.getGlobalConfig()
  },
  computed: {
    userHistoryInputVcode () {
      return localStorage.getItem('vcode')
    },
    openQrcodeDialog () {
      return this.globalConfig.switch_qr && this.userHistoryInputVcode !== this.constantVcode
    }
  },
  watch: {
    globalConfig (v) {
      if (this.globalConfig.switch_wm) {
        const wm = this.globalConfig.text_wm
        watermark.set(wm, document.documentElement)
      }
    }
  },
  methods: {
    getGlobalConfig: async function () {
      const cateListResponse = await axios.get('/api/config')
      const response = cateListResponse.data
      if (response.code === 0) {
        this.globalConfig = response.data
      }
    },
    handleSelect (i) {
      this.activeIndex = i
    },
    verify () {
      if (this.vcode === '') {
        this.$message({ message: '请输入验证码', type: 'error', duration: 1000 })
        return
      }
      if (this.vcode === this.constantVcode) {
        this.dialogVisible = false
        this.$message({ message: '验证成功', type: 'success', duration: 1000 })
        localStorage.setItem('vcode', this.vcode)
      } else {
        this.$message({ message: '验证失败', type: 'error', duration: 1000 })
      }
    }
  }
}
</script>

<style scoped>
.logo {
  position: absolute;
  top: 6px;
  left: 16px;
  width: 48px;
  height: 48px;
  border-radius: 48px;
  z-index: 100;
}
.menu {
  padding-left: 62px;
}
.dialog .title {
  text-align: center;
  font-size: 20px;
  line-height: 24px;
}
.dialog .title strong {
  color: #409eff;
  cursor: pointer;
}
.dialog .wechat {
  height: 16px;
  width: 16px;
}
.dialog .qrc {
  text-align: center;
}
.dialog .qrc img {
  width: 100%;
  height: 100%;
  max-width: 284px;
}
.dialog .tips {
  line-height: 28px;
  margin: 0px 8px 12px;
}
.dialog .tips .finish {
  text-align: center;
  text-decoration: underline;
  color: #409eff;
  font-size: 12px;
  margin: 10px 0;
}
</style>

<style>
* {
  margin: 0;
  padding: 0;
}
.container {
  margin: 10px;
}
.renyang.el-menu-item.is-disabled {
  opacity: 1;
  cursor: default;
}
.dialog .el-dialog__title {
  color: #67c23a;
  cursor: pointer;
  font-size: 22px;
}
.dialog .el-dialog__body {
  padding: 10px;
  max-width: 100%;
}
</style>
